// The compact table of the core (DESIGN.md «Реестр»): short lists that are not records of a section — files, people of a role.
// Screens give columns and rows; the markup, the phone layout (labels before values) and the keyboard are this component's.

import type { ReactNode } from 'react';
import { cx } from '../ui/primitives.tsx';
import t from './compact.module.css';

export interface CompactColumn<R> { key: string; label: string; render: (row: R) => ReactNode; className?: string }

export function CompactTable<R>({ columns, rows, rowKey, onOpen, className, cardsOnPhone, label }: {
  columns: CompactColumn<R>[]; rows: R[]; rowKey: (row: R, i: number) => string; onOpen?: (row: R) => void; className?: string;
  /** On a phone each row becomes a card: the first cell on top, the others as «label value» lines (DESIGN.md «Таблица»). */
  cardsOnPhone?: boolean;
  /** The table's name for a screen reader. */
  label?: string;
}) {
  return (
    <table className={cx(t.table, cardsOnPhone && t.cards, className)} aria-label={label}>
      <thead><tr>{columns.map((c) => <th key={c.key}>{c.label}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={rowKey(r, i)} {...(onOpen ? { onClick: () => onOpen(r), tabIndex: 0, onKeyDown: (e: React.KeyboardEvent) => { if (e.key === 'Enter') onOpen(r); } } : {})}>
            {columns.map((c) => <td key={c.key} data-label={c.label || undefined} className={c.className}>{c.render(r)}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
